export const getAnalyticsSubnav = () => {
  return [
    {
      title: 'Sessions',
      to: '/analytics/sessions',
    },
    {
      title: 'Tours',
      to: '/analytics/tours',
    },
    {
      title: 'Stops',
      to: '/analytics/stops',
    },
    {
      title: 'Visitor Traffic',
      to: '/analytics/visitor-traffic',
    },
  ];
};
